/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Status_StartingInputs */

const en_iconik_publish_status_starting = /** @type {(inputs: Iconik_Publish_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting publish workflow`)
};

const fr_iconik_publish_status_starting = /** @type {(inputs: Iconik_Publish_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrage du flux de publication`)
};

const de_iconik_publish_status_starting = /** @type {(inputs: Iconik_Publish_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starten des Veröffentlichungs-Workflows`)
};

const it_iconik_publish_status_starting = /** @type {(inputs: Iconik_Publish_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio del flusso di lavoro di pubblicazione`)
};

const ru_iconik_publish_status_starting = /** @type {(inputs: Iconik_Publish_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запуск процесса публикации`)
};

const es_iconik_publish_status_starting = /** @type {(inputs: Iconik_Publish_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando el flujo de trabajo de publicación`)
};

const zh_cn2_iconik_publish_status_starting = /** @type {(inputs: Iconik_Publish_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动发布工作流程`)
};

const ja_iconik_publish_status_starting = /** @type {(inputs: Iconik_Publish_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開ワークフローの開始`)
};

const hi_iconik_publish_status_starting = /** @type {(inputs: Iconik_Publish_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशन कार्यप्रवाह प्रारंभ करना`)
};

const pt_pt2_iconik_publish_status_starting = /** @type {(inputs: Iconik_Publish_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando o fluxo de trabalho de publicação`)
};

/**
* | output |
* | --- |
* | "Starting publish workflow" |
*
* @param {Iconik_Publish_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_status_starting = /** @type {((inputs?: Iconik_Publish_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_status_starting(inputs)
	if (locale === "de") return de_iconik_publish_status_starting(inputs)
	if (locale === "it") return it_iconik_publish_status_starting(inputs)
	if (locale === "ru") return ru_iconik_publish_status_starting(inputs)
	if (locale === "es") return es_iconik_publish_status_starting(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_status_starting(inputs)
	if (locale === "ja") return ja_iconik_publish_status_starting(inputs)
	if (locale === "hi") return hi_iconik_publish_status_starting(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_status_starting(inputs)
	return en_iconik_publish_status_starting(inputs)
});